import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Router } from '@angular/router';
import { IUserProfile } from '../model/IUserProfile';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  public authLogin = 'authlogin';

  constructor(private storage: Storage, private router: Router) { }

  setLocal(key, value): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.storage.set(key, value).then((res) => {
        return resolve(res);
      })
        .catch(error => reject(error));
    });
  }

  getLocal(key): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.storage.get(key).then((res) => {
        return resolve(res);
      })
        .catch((error) => reject(error));
    });
  }

  removeLocal(key): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.storage.remove(key).then((res) => {
        return resolve(res);
      })
        .catch((error) => reject(error));
    });
  }

  getLoggedUser(): Promise<IUserProfile> {
    return this.getLocal(this.authLogin);
  }

  isUserLoggedIn(): Observable<boolean> {

    const subject = new Subject<boolean>();
    this.getLocal(this.authLogin).then((res: IUserProfile) => {
      if (res) {
        subject.next(true);
      } else {
        subject.next(false);
      }
    });
    return subject.asObservable();
  }



  logOut() {
    localStorage.clear();
    this.storage.remove(this.authLogin).then(() => {
      this.router.navigate(['/login']);
    });
  }
}
